<template>
  <div class="attendance-group-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button
              type="primary"
              size="medium"
              :icon="buttonType === 'icon' ? 'iconfont icon-tianjiacaidan2' : ''"
              @click="handleAdd"
            >{{ buttonType === 'text' ? '新增' : '' }}</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="班次名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="请输入班次名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="考勤时间">
              <el-time-picker
                v-model="searchCondition.check_time"
                value-format="HH:mm"
                format="HH:mm"
                placeholder="筛选包含该时间的班次"
                clearable
                style="width: 200px;"
              />
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="searchCondition.status"
                placeholder="全部"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="无效" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="状态" width="90">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 1 ? 'success' : 'info'"
                size="small"
              >
                {{ scope.row.status === 1 ? "有效" : "无效" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleBindTasks(scope.row)"
                >关联任务</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                class="danger-text"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <!-- 新增/编辑班次弹窗 -->
    <el-dialog
      :title="editDialog.title"
      :visible.sync="editDialog.visible"
      width="1000px"
      :close-on-click-modal="false"
      @close="handleEditClose"
    >
      <div v-if="editDialog.deferredTip" class="edit-tip">
        <i class="el-icon-warning"></i> {{ editDialog.deferredTip }}
      </div>
      <el-form
        :model="formData"
        :rules="rules"
        ref="groupForm"
        label-position="right"
        label-width="120px"
        class="attendance-group-form"
      >
        <el-form-item label="班次名称:" prop="name" required>
          <el-input
            v-model="formData.name"
            placeholder="请输入班次名称"
            style="width: 360px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态:" required>
          <el-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="0"
            active-text="有效"
            inactive-text="无效"
          ></el-switch>
        </el-form-item>
        <el-form-item label="关联任务:">
          <el-button type="primary" size="small" @click="taskDialog.visible = true"
            >设置</el-button
          >
          <el-table
            :data="formData.tasks"
            border
            size="small"
            style="width: 100%; margin-top: 8px; max-width: 480px;"
          >
            <el-table-column prop="task_name" label="任务名称" min-width="120"></el-table-column>
            <el-table-column prop="count" label="人数" width="80" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="handleViewTaskList(scope.row)"
                  >查看名单</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="打卡时段:" required label-position="top">
          <ShiftPeriodViewTable
            :periods="formData.periods"
            :editable="true"
            :is-view="false"
            @input="formData.periods = $event"
          />
        </el-form-item>
        <el-form-item label="迟到设置:" prop="late_minutes" required>
          <div class="form-row-with-hint">
            <el-time-picker
              v-model="lateMinutesPicker"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="请选择"
              style="width: 160px;"
            />
            <span class="form-item-hint">工作时间+设置时间内打卡视为迟到</span>
          </div>
        </el-form-item>
        <el-form-item label="缺卡设置:" prop="absent_minutes" required>
          <div class="form-row-with-hint">
            <el-time-picker
              v-model="absentMinutesPicker"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="请选择"
              style="width: 160px;"
            />
            <span class="form-item-hint">工作时间+设置时间外打卡视为缺卡</span>
          </div>
        </el-form-item>
        <el-form-item label="打卡方式:">
          <el-checkbox v-model="attendanceMethodChecked" disabled>定位打卡</el-checkbox>
        </el-form-item>
        <el-form-item v-if="formData.attendance_method === 'location'" label="打卡地点设置:" required>
          <el-table :data="formData.tasks" border size="small" style="width: 100%; max-width: 560px;">
            <el-table-column prop="task_name" label="任务名称" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.task_name || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="工作地点" min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.all_address || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="打卡范围" width="140" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.punch_range_m"
                  placeholder="请选择"
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="m in PUNCH_RANGE_OPTIONS"
                    :key="m"
                    :label="`${m}米`"
                    :value="m"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialog.visible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleSubmit"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 编辑表单内：关联任务设置 -->
    <TaskSettingDialog
      :visible.sync="taskDialog.visible"
      :value="formData.tasks"
      @input="formData.tasks = $event"
    />

    <!-- 列表「关联任务」：仅选任务并增量绑定，不打开编辑弹窗 -->
    <TaskSettingDialog
      dialog-title="关联任务"
      :visible.sync="bindMissionDialog.visible"
      :value="[]"
      @input="onBindMissionsConfirm"
    />

  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ShiftPeriodViewTable from "./components/ShiftPeriodViewTable";
import TaskSettingDialog from "./components/TaskSettingDialog";
import { mapGetters } from "vuex";

// 打卡范围可选值（米），默认500
const PUNCH_RANGE_OPTIONS = [100, 150, 200, 250, 300, 350, 400, 450, 500];

export default {
  name: "ShiftManage",
  components: { PageHeaderLayout, ApeTable, ShiftPeriodViewTable, TaskSettingDialog },
  data() {
    return {
      PUNCH_RANGE_OPTIONS,
      searchCondition: {
        name: "",
        check_time: null,
        status: "",
      },
      loadingStatus: true,
      columns: [
        {
          title: "班次名称",
          value: "name",
          header_align: "center",
          align: "center",
        },
        {
          title: "任务名称",
          value: "_missionNamesText",
          header_align: "center",
          align: "center",
        },
        {
          title: "打卡时间",
          value: "_checkTimesText",
          header_align: "center",
          align: "center",
        },
        {
          title: "更新时间",
          value: "updated_at",
          header_align: "center",
          align: "center",
        },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        offset: 0,
      },
      editDialog: {
        visible: false,
        title: "新增班次",
        isEdit: false,
        deferredTip: "",
      },
      formData: {
        id: null,
        name: "",
        status: 1,
        tasks: [],
        periods: [
          {
            in_date: "",
            out_date: "",
            clock_in: "",
            clock_out: "",
            break_time: ["", ""],
            in_start: "",
            in_end: "",
            out_start: "",
            out_end: "",
          },
        ],
        attendance_method: "location",
      },
      rules: {
        name: [
          { required: true, message: "请输入班次名称", trigger: "blur" },
        ],
        late_minutes: [
          {
            required: true,
            validator: (rule, value, cb) => {
              const n = Number(value);
              if (value == null || value === "" || Number.isNaN(n) || n < 0) {
                cb(new Error("请设置迟到时间"));
              } else {
                cb();
              }
            },
            trigger: "change",
          },
        ],
        absent_minutes: [
          {
            required: true,
            validator: (rule, value, cb) => {
              const n = Number(value);
              if (value == null || value === "" || Number.isNaN(n) || n < 0) {
                cb(new Error("请设置缺卡时间"));
              } else {
                cb();
              }
            },
            trigger: "change",
          },
        ],
      },
      taskDialog: { visible: false },
      bindMissionDialog: {
        visible: false,
        shiftId: null,
      },
    };
  },
  watch: {
    "bindMissionDialog.visible"(v) {
      if (!v) this.bindMissionDialog.shiftId = null;
    },
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    attendanceMethodChecked: {
      get() {
        return this.formData.attendance_method === "location";
      },
      set(val) {
        this.formData.attendance_method = val ? "location" : null;
      },
    },
    lateMinutesPicker: {
      get() {
        return this.minutesToHHmm(this.formData.late_minutes);
      },
      set(v) {
        this.formData.late_minutes = v ? this.hhmmToMinutes(v) : 30;
      },
    },
    absentMinutesPicker: {
      get() {
        return this.minutesToHHmm(this.formData.absent_minutes);
      },
      set(v) {
        this.formData.absent_minutes = v ? this.hhmmToMinutes(v) : 90;
      },
    },
  },
  methods: {
    getDefaultFormData() {
      return {
        id: null,
        name: "",
        status: 1,
        tasks: [],
        periods: [
          {
            in_date: "",
            out_date: "",
            clock_in: "",
            clock_out: "",
            break_time: ["", ""],
            in_start: "",
            in_end: "",
            out_start: "",
            out_end: "",
          },
        ],
        attendance_method: "location",
        late_minutes: 30,
        absent_minutes: 90,
      };
    },
    minutesToHHmm(total) {
      const n = Math.max(0, Math.min(24 * 60 - 1, Number(total) || 0));
      const h = Math.floor(n / 60);
      const m = n % 60;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },
    hhmmToMinutes(s) {
      if (!s || typeof s !== "string") return 0;
      const parts = s.split(":");
      const h = parseInt(parts[0], 10) || 0;
      const mm = parseInt(parts[1], 10) || 0;
      return Math.min(24 * 60 - 1, Math.max(0, h * 60 + mm));
    },
    joinWith(arr) {
      if (!arr || !Array.isArray(arr) || !arr.length) return "";
      return arr.filter(Boolean).join("、");
    },
    apiPeriodToForm(p) {
      const breakArr =
        p.break_start_time && p.break_end_time
          ? [p.break_start_time, p.break_end_time]
          : ["", ""];
      const workOut = p.work_end_time || "";
      return {
        in_date: p.start_date || "",
        out_date: p.end_date || "",
        clock_in: p.work_start_time || "",
        clock_out: workOut,
        break_time: breakArr,
        in_start: p.check_start_time || "",
        in_end: p.check_end_time || "",
        out_start: p.end_check_start_time,
        out_end: p.end_check_end_time,
      };
    },
    workShiftApiToFormPeriods(apiPeriods) {
      if (!apiPeriods || !apiPeriods.length) return [];
      return apiPeriods.map((p) => this.apiPeriodToForm(p));
    },
    formPeriodsToWorkShiftApi(formPeriods) {
      if (!formPeriods || !formPeriods.length) return [];
      return formPeriods.map((p) => {
        const bt = Array.isArray(p.break_time) ? p.break_time : null;
        return {
          start_date: p.in_date,
          end_date: p.out_date,
          work_start_time: p.clock_in,
          work_end_time: p.clock_out,
          break_start_time: bt && bt[0] ? bt[0] : undefined,
          break_end_time: bt && bt[1] ? bt[1] : undefined,
          check_start_time: p.in_start,
          check_end_time: p.in_end,
          end_check_start_time: p.out_start,
          end_check_end_time: p.out_end,
        };
      });
    },
    checkPeriodsOverlap() {
      const periods = this.formData.periods || [];
      for (let i = 0; i < periods.length; i++) {
        if (!periods[i].in_date || !periods[i].out_date || !periods[i].clock_in || !periods[i].clock_out) {
          this.$message.error(`第${i + 1}个时段的打卡日期和打卡时间不能为空`);
          return false;
        }
        if (!this.isPeriodDateTimeValid(periods[i])) {
          this.$message.error(`第${i + 1}个时段的开始日期时间不能晚于结束日期时间`);
          return false;
        }
        for (let j = i + 1; j < periods.length; j++) {
          if (!periods[j].in_date || !periods[j].out_date || !periods[j].clock_in || !periods[j].clock_out) continue;
          if (this.isTimeOverlap(periods[i], periods[j])) {
            this.$message.error(`第${i + 1}个时段与第${j + 1}个时段日期时间重叠`);
            return false;
          }
        }
      }
      return true;
    },
    isTimeOverlap(a, b) {
      const aStart = this.toDateTimeValue(a.in_date, a.clock_in);
      const aEnd = this.toDateTimeValue(a.out_date, a.clock_out);
      const bStart = this.toDateTimeValue(b.in_date, b.clock_in);
      const bEnd = this.toDateTimeValue(b.out_date, b.clock_out);
      return aStart < bEnd && bStart < aEnd;
    },
    toDateTimeValue(dateStr, timeStr) {
      if (!dateStr || !timeStr) return null;
      return new Date(`${dateStr} ${timeStr}`).getTime();
    },
    isPeriodDateTimeValid(period) {
      const start = this.toDateTimeValue(period.in_date, period.clock_in);
      const end = this.toDateTimeValue(period.out_date, period.clock_out);
      if (start == null || end == null) return false;
      return start <= end;
    },
    checkPunchTimeRange() {
      const toMin = (t) => {
        if (!t) return null;
        const parts = String(t).split(":");
        const h = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        if (Number.isNaN(h)) return null;
        return (h || 0) * 60 + (Number.isNaN(m) ? 0 : m);
      };
      const periods = this.formData.periods || [];
      for (let i = 0; i < periods.length; i++) {
        const p = periods[i];
        const workIn = toMin(p.clock_in);
        const workOut = toMin(p.clock_out);
        const punchInStart = toMin(p.in_start);
        const punchOutStart = toMin(p.out_start);
        const punchOutEnd = toMin(p.out_end);
        if (workIn != null && punchInStart != null && punchInStart > workIn) {
          this.$message.error(`第${i + 1}个时段：开始打卡开始时间不能晚于开始工作时间`);
          return false;
        }
        if (workOut != null && punchOutStart != null && punchOutStart < workOut) {
          this.$message.error(`第${i + 1}个时段：结束打卡开始时间不能早于结束工作时间`);
          return false;
        }
        if (workOut != null && punchOutEnd != null && punchOutEnd < workOut) {
          this.$message.error(`第${i + 1}个时段：结束打卡结束时间不能早于结束工作时间`);
          return false;
        }
        if (
          punchOutStart != null &&
          punchOutEnd != null &&
          punchOutEnd < punchOutStart
        ) {
          this.$message.error(`第${i + 1}个时段：结束打卡结束时间不能早于结束打卡开始时间`);
          return false;
        }
      }
      return true;
    },
    handleViewTaskList(row) {
      const taskId = row.task_id != null ? row.task_id : row.id;
      if (taskId == null || taskId === "") {
        this.$message.warning("缺少任务 ID，无法查看名单");
        return;
      }
      this.$router.push({
        path: "/taskCustomer",
        query: { task_id: String(taskId), task_type: 1 },
      });
    },
    searchButton() {
      this.initList();
    },
    resetSearch() {
      this.searchCondition = {
        name: "",
        check_time: null,
        status: "",
      };
      this.initList();
    },
    async switchPaging() {
      this.initList();
    },
    handleAdd() {
      this.editDialog.title = "新增班次";
      this.editDialog.isEdit = false;
      this.editDialog.deferredTip = "";
      this.formData = { ...this.getDefaultFormData() };
      this.editDialog.visible = true;
    },
    mapTaskFromMission(m) {
      return {
        id: m.id,
        task_id: m.id,
        task_name: m.name || m.task_name || "",
        count: m.person_num != null ? m.person_num : m.count != null ? m.count : 0,
        all_address: m.all_address || "",
        punch_range_m: m.check_range != null ? m.check_range : m.punch_range_m != null ? m.punch_range_m : 500,
      };
    },
    handleBindTasks(row) {
      if (!row || !row.id) return;
      this.bindMissionDialog.shiftId = row.id;
      this.bindMissionDialog.visible = true;
    },
    async onBindMissionsConfirm(tasks) {
      const shiftId = this.bindMissionDialog.shiftId;
      if (!shiftId) return;
      const list = tasks || [];
      if (!list.length) {
        this.$message.warning("请至少选择一个任务");
        return;
      }
      const missions = list.map((t) => ({
        mission_id: String(t.task_id != null ? t.task_id : t.id),
        check_range: t.punch_range_m != null ? t.punch_range_m : 500,
      }));
      try {
        const data = await this.$api.workShiftBindMissions({ shift_id: String(shiftId), missions });
        const d = data && typeof data === "object" ? data : {};
        const added = d.added_count != null ? d.added_count : 0;
        const skipped = d.skipped_count != null ? d.skipped_count : 0;
        let msg = `本次新增绑定 ${added} 个任务`;
        if (skipped > 0) msg += `，${skipped} 个已绑定已跳过`;
        this.$message.success(msg);
        this.initList();
      } catch (e) {
        console.error(e);
      }
    },
    handleDelete(row) {
      this.$confirm("确认删除该班次？", "提示", { type: "warning" })
        .then(async () => {
          try {
            await this.$api.workShiftDelete(row.id);
            this.$message.success("已删除");
            this.initList("del");
          } catch (e) {
            const msg =
              (e && e.data && e.data.message) ||
              (e && e.message) ||
              (typeof e === "string" ? e : "") ||
              "删除失败";
            console.error(msg, e);
          }
        })
        .catch(() => {});
    },
    async handleEdit(row) {
      this.editDialog.title = "编辑班次";
      this.editDialog.isEdit = true;
      try {
        const info = await this.$api.workShiftView(row.id);
        const d = info && typeof info === "object" ? info : {};
        this.editDialog.deferredTip =
          (d.pending_edit && d.pending_edit.message) ||
          (d.has_bound_mission ? "因当前已存在关联任务，次日生效" : "");
        this.formData = {
          ...this.getDefaultFormData(),
          id: d.id,
          name: d.name || "",
          status: d.status != null ? d.status : 1,
          tasks: (d.mission_list || []).map((m) => this.mapTaskFromMission(m)),
          periods:
            d.periods && d.periods.length
              ? this.workShiftApiToFormPeriods(d.periods)
              : this.getDefaultFormData().periods,
          attendance_method: d.check_method === 1 ? "location" : "location",
          late_minutes: d.late_minutes != null ? Number(d.late_minutes) : 30,
          absent_minutes: d.absent_minutes != null ? Number(d.absent_minutes) : 90,
        };
        this.editDialog.visible = true;
      } catch (e) {
        const msg = (e && e.data && e.data.message) || (e && e.msg) || e.message || "获取班次详情失败";
        console.error(msg, e);
      }
    },
    handleSubmit() {
      this.$refs["groupForm"].validate((valid) => {
        if (!valid) {
          this.$message.error("请检查必填项！");
          return;
        }
        if (!this.checkPeriodsOverlap()) return;
        if (!this.checkPunchTimeRange()) return;
        this.formSubmit();
      });
    },
    async formSubmit() {
      const missions = (this.formData.tasks || [])
        .filter((t) => t.task_id)
        .map((t) => ({
          mission_id: String(t.task_id),
          check_range: t.punch_range_m != null ? t.punch_range_m : 500,
        }));
      const payload = {
        name: this.formData.name,
        late_minutes: Number(this.formData.late_minutes) || 0,
        absent_minutes: Number(this.formData.absent_minutes) || 0,
        check_method: 1,
        status: this.formData.status,
        periods: this.formPeriodsToWorkShiftApi(this.formData.periods),
        missions,
      };
      if (this.formData.id) payload.id = this.formData.id;
      try {
        const res = await this.$api.workShiftStore(payload);
        if (res && typeof res === "object" && res.deferred) {
          this.$message.success(res.message || "保存成功，次日生效");
          this.editDialog.visible = false;
          this.initList();
          return;
        }
        if (res !== undefined && res !== null && res !== false) {
          this.$message.success("保存成功!");
          this.editDialog.visible = false;
          this.initList();
        } else {
          console.error("保存失败");
        }
      } catch (e) {
        const msg = (e && e.data && e.data.message) || (e && e.msg) || e.message || "保存失败";
        console.error(msg, e);
      }
    },
    handleEditClose() {
      this.$nextTick(() => {
        if (this.$refs["groupForm"]) {
          this.$refs["groupForm"].resetFields();
        }
      });
    },
    async initList(type) {
      this.loadingStatus = true;
      try {
        const pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
        const params = {
          name: this.searchCondition.name || undefined,
          check_time: this.searchCondition.check_time || undefined,
          status: this.searchCondition.status === "" ? undefined : this.searchCondition.status,
          current_page: pagingInfo.current_page,
          page_size: pagingInfo.page_size,
        };
        const res = await this.$api.workShiftList(params);
        const list = (res && res.list) || [];
        const pages = (res && res.pages) || {};
        this.tableList = list.map((item) => ({
          ...item,
          _missionNamesText: this.joinWith(item.mission_names),
          _checkTimesText: this.joinWith(item.check_times),
        }));
        this.pagingData.total = pages.total || 0;
        const off = pages.offset;
        this.pagingData.offset =
          off != null ? off : (pagingInfo.current_page - 1) * pagingInfo.page_size;
      } catch (e) {
        this.tableList = [];
        const msg = (e && e.data && e.data.message) || (e && e.msg) || e.message || "加载失败";
        console.error(msg, e);
      } finally {
        this.loadingStatus = false;
      }
    },
  },
  mounted() {
    this.initList();
  },
};
</script>

<style lang="scss" scoped>
.attendance-group-page {
  ::v-deep {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 10px;
    }
    .el-date-editor .el-range-input{
      width: 100%;
    }
    .el-table th {
      line-height: normal;
    }
  }
}
.edit-tip {
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  padding: 8px 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  font-size: 14px;

  .el-icon-warning {
    margin-right: 6px;
  }
}

.attendance-group-form {
  .text-placeholder {
    color: #c0c4cc;
  }
  .form-row-with-hint {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }
  .form-item-hint {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    flex: 1;
    min-width: 240px;
  }
}

.danger-text {
  color: #f56c6c;
}
</style>
